import PropTypes from "prop-types"
import React from "react"

import IconSvg from "@atoms/IconSvg/IconSvg"
import searchIcon from "@images/svg/Search-icon-white.svg"

const SearchInput = ({
  placeholder,
  value,
  widthClass = "w-auto",
  onChange,
  onSearch,
}) => (
  <div className={`relative inline-block ${widthClass}`}>
    <input
      className="w-full rounded-full ring-1 ring-gray-200 focus:ring-brand-blue text-sm leading-3 px-4 py-2.5 placeholder:text-gray-400 font-normal appearance-none"
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onKeyPress={({ key }) => key === "Enter" && onSearch()}
    />
    <button
      className="absolute top-1.5 right-1.5 w-5.5 h-5.5 rounded-full bg-gray-50 hover:bg-gray-100 text-blue-900"
      onClick={onSearch}
    >
      <IconSvg Icon={searchIcon} widthClass="w-2.5" />
    </button>
  </div>
)

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  widthClass: PropTypes.string,
  onChange: PropTypes.func,
}

export default SearchInput
